module.exports = __webpack_public_path__ + "comunicados.png?cf734aab3250770395b490d5267ca9cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty/comunicados.png
// module id = 30
// module chunks = 0